module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_04_6DC79_1SD_G9K.fca8de38.png";